import Tabs from './nav';
import { VoucherBookGenerate } from './generate';

interface IProps {
    subTabKey: string
}

const VoucherBook = (props: IProps) => {
    return (
        <>
            <Tabs subTabKey={props.subTabKey} />

            {props.subTabKey == 'GENERATE' && <VoucherBookGenerate />}
        </>
    );
}

export default VoucherBook;
